
export const CARD_PER_PAGE = 4;